import Intercom from '@intercom/messenger-js-sdk';

export default {
  install: (app) => {
    const intercomService = {
      init: (userData) => {
        if (!userData) return;

        try {
          const user = {
            id: userData.id,
            name: userData.name || `${userData.first_name || ''} ${userData.last_name || ''}`.trim(),
            email: userData.email,
            createdAt: userData.createdAt || userData.created_at,
          };

          if (!user.id || !user.email) {
            console.warn('Missing required user data for Intercom initialization');
            return;
          }

          Intercom({
            app_id: 'm5qffamv',
            user_id: user.id,
            z_index: 1000,
            name: user.name,
            email: user.email,
            created_at: user.createdAt ? Math.floor(new Date(user.createdAt).getTime() / 1000) : undefined,
          });
        } catch (error) {
          console.error('An error occurred while initializing Intercom: ', error);
        }
      },
      update: (data) => {
        try {
          if (window.Intercom) {
            Intercom('update', data);
          }
        } catch (error) {
          console.error('Error updating Intercom:', error);
        }
      },
      trackEvent: (eventName, metadata) => {
        try {
          if (window.Intercom) {
            Intercom('trackEvent', eventName, metadata);
          }
        } catch (error) {
          console.error('Error tracking Intercom event:', error);
        }
      },
      showMessages: () => {
        try {
          if (window.Intercom) {
            window.Intercom('show');
          }
        } catch (error) {
          console.error('Error showing Intercom messages:', error);
        }
      },
      hideMessages: () => {
        try {
          if (window.Intercom) {
            Intercom('hide');
          }
        } catch (error) {
          console.error('Error hiding Intercom messages:', error);
        }
      },
    };

    app.provide('intercom', intercomService);
  },
};
